export default __webpack_public_path__ + "static/media/sleet.dc4e3c17.mp4";